import { blockedOrdersSearchSchema } from '@/hooks/queries/credit/useBlockedOrders'
import { createFileRoute } from '@tanstack/react-router'
import { BlockedOrdersCockpitPage } from '../-components/BlockedOrdersCockpitPage'

export const Route = createFileRoute('/_auth/_modules/credit/blocked-orders/resolved/')({
  component: RouteComponent,
  validateSearch: (search) => blockedOrdersSearchSchema.parse(search),
})

/** What was finally decided: each release, rejection or deletion, by decision or one per order. */
function RouteComponent() {
  const navigate = Route.useNavigate()
  const search = Route.useSearch()
  return <BlockedOrdersCockpitPage kind="resolved" search={search} navigate={navigate} />
}
